<template>
  <router-link
    class="m-the-header-logo"
    to="/gestion/productos-de-vidroop"
  >
    <AtomLogoPrimary/>
  </router-link>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderLogo'
}
</script>
